// Names of the columns that hold a type, a state or a source. Their values are translated in
// enumValues.ts and enumLabels.ts; without a name here the page shows the property as written in code.
export const TYPE_COLUMN_LABELS: Record<string, string> = {
  ApplicationType: "Lloji i aplikimit",
  ReviewType: "Lloji i vlerësimit",
  JourneyType: "Lloji i udhëtimit",
  LineType: "Lloji i linjës",
  StationType: "Lloji i stacionit",
  SubscriptionType: "Lloji i abonimit",
  RewardType: "Lloji i shpërblimit",
  UsageMode: "Mënyra e përdorimit",
  CostType: "Lloji i kostos",
  ReservationType: "Lloji i rezervimit",
  PromotionCodeType: "Lloji i kodit",
  PromotionCodeApplicationType: "Aplikohet për",
  EsimDataRange: "Sasia e të dhënave",
  QuestionFor: "Pyetja për",
  HashReason: "Arsyeja",
  Source: "Burimi",
  EntityType: "Lloji",
  SeatNumber: "Numri i uljes",
  FloorNumber: "Numri i katit",
  PlateNumber: "Targa",
  Slug: "Adresa (slug)",
  BizSlug: "Adresa (slug)",
  ValidityDays: "Ditë vlefshmërie",
  DataBytes: "Sasia e të dhënave",
  Cost: "Kostoja",
  OldCost: "Kostoja e vjetër",
  IsRecommended: "E rekomanduar",
  IsUnlimited: "E palimituar",
  IncludeInHomepage: "Në faqen kryesore",
  IsSystemRole: "Rol i sistemit",
  ExpirationDate: "Skadon më",
  ExpiresAtUtc: "Skadon më",
  NumberOfTimesUsed: "Herë të përdorura"
};
